import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const row = css`
  display: flex;
  align-items: flex-start;
  margin-top: ${rem(8)};

  & > *:first-of-type {
    flex: 1;
    margin-right: ${rem(16)};
  }

  & > *:last-of-type {
    min-width: ${rem(136)};
  }
`

const field = css`
  & :first-of-type {
    margin-bottom: 0;
  }
`

export const styles = {
  row,
  field,
}
